import React, { useState, useEffect } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const testimonials = [
  {
    id: 1,
    logo: "e-Filing",
    logoSubtext: "Income Tax Department Government of India",
    quote: "TwoKey has enabled us to complete questionnaires quickly and accurately, and has had a hugely positive effect on speeding up our sales cycle.",
    name: "Desiree R",
    title: "Sr. Director of Information Security",
    avatar: "https://i.pravatar.cc/150?img=47",
  },
  {
    id: 2,
    logo: "TechCorp",
    logoSubtext: "Enterprise Solutions",
    quote: "The security features of TwoKey have transformed how we share sensitive documents. The granular access controls give us complete peace of mind.",
    name: "Michael Chen",
    title: "Chief Technology Officer",
    avatar: "https://i.pravatar.cc/150?img=12",
  },
  {
    id: 3,
    logo: "SecureBank",
    logoSubtext: "Financial Services",
    quote: "TwoKey's encryption and audit trails have been essential for our compliance requirements. It's become an integral part of our workflow.",
    name: "Sarah Johnson",
    title: "VP of Compliance",
    avatar: "https://i.pravatar.cc/150?img=45",
  },
  {
    id: 4,
    logo: "MedTech Solutions",
    logoSubtext: "Healthcare Technology",
    quote: "The ability to control access and track file interactions has been crucial for our HIPAA compliance. TwoKey makes secure sharing effortless.",
    name: "Dr. James Wilson",
    title: "Chief Medical Officer",
    avatar: "https://i.pravatar.cc/150?img=33",
  },
  {
    id: 5,
    logo: "Global Manufacturing",
    logoSubtext: "Industrial Solutions",
    quote: "TwoKey has streamlined our document sharing process across multiple departments and locations. The user experience is excellent.",
    name: "Robert Martinez",
    title: "Operations Director",
    avatar: "https://i.pravatar.cc/150?img=28",
  },
];

const HomeTestimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000); // Change testimonial every 5 seconds

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToPrevious = () => {
    setIsAutoPlaying(false);
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      goToNext();
    }
    if (isRightSwipe) {
      goToPrevious();
    }
  };

  return (
    <div className="bg-[#F1F1FF] py-12 md:py-16 lg:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <div className="text-center mb-10 md:mb-12 space-y-3">
          <h5 className="text-sm md:text-base font-semibold text-[#5E5ADB] uppercase tracking-wider">
            TESTIMONIALS
          </h5>
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#1C1C1C] font-familjenGrotesk">
            Trusted by <span className="bg-gradient-to-r from-[#5E5ADB] to-[#C8C6FF] bg-clip-text text-transparent">top companies</span>
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            See what industry leaders say about Twokey's security and collaboration features
          </p>
        </div>

        {/* Moving Banner Style Carousel */}
        <div className="relative overflow-hidden">
          <div 
            className="overflow-hidden"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <div
              className="flex transition-transform duration-500 ease-in-out gap-4 md:gap-6"
              style={{
                transform: `translateX(-${currentIndex * 100}%)`,
              }}
            >
              {testimonials.map((testimonial) => (
                  <div
                    key={testimonial.id}
                  className="min-w-full flex-shrink-0 px-2 md:px-4"
                  >
                  <div className="bg-white rounded-2xl shadow-lg p-5 md:p-6 lg:p-8 border border-[#5E5ADB]/20 max-w-4xl mx-auto">
                    <div className="flex flex-col md:flex-row gap-5 md:gap-6 items-start">
                      {/* Left: Logo and Avatar */}
                      <div className="flex flex-col items-center md:items-start gap-4 md:min-w-[200px]">
                        <div className="text-center md:text-left">
                          <h3 className="text-lg md:text-xl font-bold text-[#131149] mb-1 font-familjenGrotesk">
                          {testimonial.logo}
                        </h3>
                          <p className="text-xs md:text-sm text-gray-500">
                          {testimonial.logoSubtext}
                        </p>
                      </div>
                        <img
                          src={testimonial.avatar}
                          alt={testimonial.name}
                          className="w-16 h-16 md:w-20 md:h-20 rounded-full object-cover ring-2 ring-[#5E5ADB]/20"
                        />
                        <div className="text-center md:text-left">
                          <p className="font-semibold text-[#131149] text-sm md:text-base">
                            {testimonial.name}
                          </p>
                          <p className="text-xs md:text-sm text-gray-600">
                            {testimonial.title}
                          </p>
                        </div>
                      </div>

                      {/* Right: Quote */}
                      <div className="flex-1">
                        <p className="text-base md:text-lg text-gray-700 leading-relaxed font-inter italic">
                          "{testimonial.quote}"
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={goToPrevious}
            className="hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 bg-white rounded-full p-2.5 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 z-10 items-center justify-center border border-[#5E5ADB]/30 hover:border-[#5E5ADB] hover:bg-[#5E5ADB]/5"
            aria-label="Previous testimonial"
          >
            <ArrowBackIosIcon className="text-[#5E5ADB] text-lg ml-0.5" />
          </button>
          <button
            onClick={goToNext}
            className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 bg-white rounded-full p-2.5 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 z-10 items-center justify-center border border-[#5E5ADB]/30 hover:border-[#5E5ADB] hover:bg-[#5E5ADB]/5"
            aria-label="Next testimonial"
          >
            <ArrowForwardIosIcon className="text-[#5E5ADB] text-lg" />
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-2 md:h-2.5 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? "bg-[#5E5ADB] w-8 md:w-10"
                    : "bg-gray-300 w-2 md:w-2.5 hover:bg-[#5E5ADB]/50"
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTestimonials;
